<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('finance_reports')" :is-filter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('finance_reports')" :is-filter="false">
                </HeaderMobile>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <ValidationObserver ref="form">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="report" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('report')">
                                        <multi-selectbox :allow-empty="false" :multiple="false"
                                                         :validate-error="errors[0]" :options="reportOptions"
                                                         v-model="form.report"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="response_type" rules="required" v-slot="{valid, errors}"
                                                    v-if="showReportType">
                                    <b-form-group :label="$t('report_type')">
                                        <multi-selectbox :allow-empty="false" :multiple="false"
                                                         :validate-error="errors[0]" :options="responseTypeOptions"
                                                         v-model="form.response_type"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showPeriod">
                                        <ValidationProvider name="period_id" :rules="required.includes('period')?'required':''" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('period')">
                                                <payment-periods-selectbox
                                                    :multiple="true"
                                                    :semesters="semesters"
                                                    :validate-error="errors[0]"
                                                    v-model="form.period_id">
                                                </payment-periods-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showCurrency">
                                        <ValidationProvider name="currency" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('currency')">
                                                <multi-selectbox
                                                    :multiple="isCurrecyMultiple"
                                                    :options="computedCurrencies"
                                                    :validate-error="errors[0]"
                                                    v-model="form.currency">
                                                </multi-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showDates">
                                        <ValidationProvider name="start_date" rules="required">
                                            <b-form-group :label="$t('start_date')">
                                                <select-date
                                                    v-model="form.start_date">
                                                </select-date>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="date">
                                        <ValidationProvider name="due_date_before" rules="required">
                                            <b-form-group :label="$t('date')">
                                                <select-date
                                                    v-model="form.due_date_before">
                                                </select-date>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showDates">
                                        <ValidationProvider name="end_date" rules="required" >
                                            <b-form-group :label="$t('end_date')">
                                                <select-date
                                                    v-model="form.end_date">
                                                </select-date>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <!--                                    <b-col sm="6" md="4" lg="4" xl="3">-->
                                    <!--                                        <b-form-group :label="$t('exam_date')">-->
                                    <!--                                            <b-form-input type="date" v-model="datatable.queryParams.filter.date"/>-->
                                    <!--                                        </b-form-group>-->
                                    <!--                                    </b-col>-->

                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showSemester">
                                        <ValidationProvider name="semester_id" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('registration_semester')">
                                                <semesters-selectbox
                                                    :validate-error="errors[0]"
                                                    v-model="form.semester_id">
                                                </semesters-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showFaculty">
                                        <ValidationProvider name="faculty_code" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('faculty_code')">
                                                <faculty-selectbox
                                                    :validate-error="errors[0]"
                                                    :multiple="isFacultyMultiple"
                                                    v-model="form.faculty_code">
                                                </faculty-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showOneRow">
                                        <ValidationProvider name="is_one_row" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('is_one_row')">
                                                <multi-selectbox :allow-empty="false" :multiple="false"
                                                                 :validate-error="errors[0]" :options="oneRowOptions"
                                                                 v-model="form.is_one_row"></multi-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showCurrencyRate">
                                        <ValidationProvider name="currency_rate" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('currency_rate')">
                                                <b-input type="number"
                                                         v-model="form.currency_rate">
                                                </b-input>
                                                <b-form-invalid-feedback v-if="errors[0]"
                                                                         v-html="errors[0]"></b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6 col-xs-12" v-if="showNumbers">
                                <ValidationProvider name="number" rules="" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('student_numbers')">
                                        <lined-textarea v-model="form.number"
                                                        :nowrap="false"
                                                        :disabled="false"
                                                        :styles="{ height: '15em', resize: 'both' }"
                                                        :validateError="errors[0]">
                                        </lined-textarea>
                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <processing-button @click="send" label="get_report"
                                                   :processing="processing"></processing-button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox";
import FinanceReportService from "@/services/FinanceReportService";
import ProcessingButton from "@/components/elements/ProcessingButton";
import LinedTextarea from "../../../components/elements/LinedTextarea";
import SemestersSelectbox from "../../../components/interactive-fields/SemestersSelectbox";
import qs from "qs";

export default {
    components: {
        SemestersSelectbox,
        LinedTextarea,
        ProcessingButton,
        PaymentPeriodsSelectbox,
        MultiSelectbox,
        AppLayout,
        ValidationProvider,
        ValidationObserver,
        Header,
        HeaderMobile
    },
    metaInfo() {
        return {
            title: this.$t('finance_reports')
        }
    },
    data() {
        return {
            showPeriod: false,
            showCurrency: false,
            isCurrecyMultiple: false,
            showDates: false,
            showSemester: false,
            showNumbers: false,
            showReportType: true,
            isFacultyMultiple: false,
            showFaculty: false,
            showOneRow: false,
            showCurrencyRate: false,

            date:false,
            form: {
                response_type: 'page'
            },
            reportOptions: [
                {value: '11', text: this.$t('scholarship_report'), permission: 'scholarship_report'},
            ],
            responseTypeOptions: [
                // {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
                // {value: 'pdf', text: 'PDF'},
            ],
            oneRowOptions: [
                {value: '1', text: this.$t('yes')},
                {value: '0', text: this.$t('no')},
            ],
            processing: false,
            reportName: "",
            semesters: null,
            currencies: [
                {value: null,  text: this.$t('select')},
                {value: 'TRY', text:'TRY'},
                {value: 'USD', text:'USD'},
                {value: 'EUR', text:'EUR'},
                {value: 'TL', text:'HEPSİ TRY'},
            ],
            showAllTL:false
        }
    },
    methods: {
        async send() {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
                this.processing = true;
                this.reportName = this.getOptionText(this.reportOptions, this.form.report);
                let config = {params: this.form};
                let oldNumber=this.form.number;

                if(['11'].includes(this.form.report)){
                    config = {...this.form};
                    if(oldNumber){
                        config.number=config.number.split(/\n/);
                    }
                }
                else {
                    if(oldNumber){
                        config.params.number=config.params.number.split(/\n/);
                    }
                }
                let isArrayBuffer=false;
                if (this.form.response_type != 'page' && !['11'].includes(this.form.report)) {
                    config.responseType = 'arraybuffer';
                    isArrayBuffer=true;
                }

                if (this.form.report == '11') {
                    FinanceReportService.scholarship(config)
                        .then(response=>{
                            this.$router.push('/job/logs/detail/'+response.data.data.job_id)
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.form, isArrayBuffer);
                        }).finally(() => {
                        this.processing = false;
                    });
                }
                else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
                this.form.number=oldNumber;
            }
        },
        callback(response) {
            if (this.form.response_type == 'page') {
                this._openFile(response);
            }
            else if (this.form.response_type == 'excel') {
                this._downloadFile(response, this.reportName + '.xlsx');
            }
            else if (this.form.response_type == 'pdf') {
                this._downloadFile(response, this.reportName + '.pdf');
            }
        }
    },
    watch: {
        'form.report'(newVal, oldVal) {

            if (newVal != oldVal) {
                this.form = {response_type: 'page', report: newVal}
            }
            this.date=false
            this.showDates = false;
            this.showPeriod = false;
            this.showCurrency = false;
            this.showReportType = true;
            this.semesters=null;
            this.showAllTL=false;
            this.showNumbers=false;
            this.isCurrecyMultiple = false;
            this.isFacultyMultiple = false;
            this.showFaculty = false;
            this.showOneRow = false;
            this.showCurrencyRate = false;

            if (newVal=='1'){
                this.date=true
            }

            if (newVal == '2') {
                this.showPeriod = true;
                this.semesters = [0,1,2,3,5,6];
                this.showCurrency = true;
            } else if (newVal == '3') {
                this.showDates = true;
                this.showPeriod = true;
                this.showCurrency = true;
                this.showAllTL=true;
            } else if (newVal == '4') {
            }
            else if (newVal == '5') {
                this.showPeriod = true;
                this.semesters = [0,1,2,3,5,6];
                this.showReportType = false;
                this.form.response_type = 'excel';
                this.showCurrency = true;
            }
            else if (newVal == '6') {
                this.showNumbers=true;
            }
            else if (newVal == '7') {
                this.showDates = true;
                this.showPeriod = true;
            }
            else if (newVal == '11') {
                this.semesters = [0,1,2,3,5,6];
                this.showPeriod = true;
                this.showSemester = true;
                this.showFaculty = true;
                this.isFacultyMultiple = true;
                this.showOneRow = true;
                this.showReportType = false;
                this.showCurrencyRate = true;
                this.showNumbers = true;
                this.required = ['period'];
            }
        }
    },
    computed:{
        computedCurrencies(){
            return this.currencies.filter((item)=>{
                return item.value!='TL' || this.showAllTL;
            })
        }
    }
};
</script>
